import { useState } from "react";
import ContactForm from "../pages/ContactForm";
import { Link } from "react-router-dom";
import { IconMail, IconHelpCircle } from "./Icons";

function Footer() {
  const [showContact, setShowContact] = useState(false);

  return (
    <>
      <div className="wireframe-footer">
        <span>© 2026 BusinessNearMe</span>

        <span
          className="footer-link footer-contact"
          onClick={() => setShowContact(true)}
        >
          <span className="icon-row">
            <IconMail size={14} />
            Contact Us
          </span>
        </span>

        <Link to="/help" className="footer-link">
          <span className="icon-row">
            <IconHelpCircle size={14} />
            Help
          </span>
        </Link>

        <div className="footer-disclaimer">
          <strong>Disclaimer:</strong> Please verify details directly with the business.
        </div>
      </div>

      {/* Contact modal */}
      {showContact && (
        <div className="modal-overlay" onClick={() => setShowContact(false)}>
          <div className="modal-card" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-btn"
              onClick={() => setShowContact(false)}
              aria-label="Close"
            >
              ✕
            </button>
            <ContactForm />
          </div>
        </div>
      )}
    </>
  );
}

export default Footer;
